import { ORG_ID } from '@/components/seo/JsonLd';
import { PRICING_CUSTOM_COPY } from '@/lib/marketing/messaging-bank';
import { wrapGraph } from '@/lib/seo/schema-builders';

const CANONICAL = PRICING_CUSTOM_COPY.metadata.canonical;

export function PricingCustomJsonLd() {
  const data = wrapGraph([
    {
      '@type': 'Service',
      '@id': `${CANONICAL}#service`,
      name: 'BizRnR Custom Enterprise Plan',
      description: PRICING_CUSTOM_COPY.metadata.description,
      provider: { '@id': ORG_ID },
      areaServed: 'United States',
      serviceType: 'Custom AI voice automation for enterprise',
    },
    {
      '@type': 'WebPage',
      '@id': `${CANONICAL}#webpage`,
      url: CANONICAL,
      name: PRICING_CUSTOM_COPY.metadata.title,
      description: PRICING_CUSTOM_COPY.metadata.description,
    },
    {
      '@type': 'BreadcrumbList',
      '@id': `${CANONICAL}#breadcrumbs`,
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://bizrnr.com' },
        { '@type': 'ListItem', position: 2, name: 'Pricing', item: 'https://bizrnr.com/pricing' },
        { '@type': 'ListItem', position: 3, name: 'Custom Enterprise', item: CANONICAL },
      ],
    },
  ]);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
